<template>
  <customize-form :schema="formModel" ref="form" />
</template>

<script>
import { getSelectList } from '@/api'
import { getCustomerInfo } from 'views/customer-mangement/detail/info/basic-profile/api'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: 'Country Name',
          key: 'country',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [],
        },
        {
          type: 'input',
          label: 'Company Name',
          key: 'companyName',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'select',
          label: 'Language',
          key: 'inLanguage',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          value: 'en-US',
          selectList: [
            {
              id: 'ja-JP',
              name: 'Japanese',
            },
            {
              id: 'zh-hans-CN',
              name: 'Simplified Chinese',
            },
            {
              id: 'zh-hant-TW',
              name: 'Traditional Chinese',
            },
            {
              id: 'ko-hang-KR',
              name: 'Hangul',
            },
            {
              id: 'en-US',
              name: 'English',
            },
          ],
        },
        {
          type: 'input',
          label: 'Telephone Number',
          key: 'mobile',
        },
        {
          type: 'input',
          label: 'Address',
          key: 'address',
        },
        {
          type: 'input',
          label: 'City',
          key: 'city',
        },
        {
          type: 'input',
          label: 'Postal Code',
          key: 'postalCode',
        },
        {
          type: 'input',
          label: 'Duns Number',
          key: 'dunsNumber',
        },
      ],
    }
  },
  created() {
    this._getCountryList()
    this._getCustomerInfo()
  },

  methods: {
    async _getCustomerInfo() {
      try {
        const { base } = await getCustomerInfo(this.$route.params.customerId)
        this.formModel.forEach((item, index) => {
          if (item.key === 'companyName') {
            this.formModel.splice(index, 1, { ...item, value: base.name })
          }
          if (item.key === 'address') {
            this.formModel.splice(index, 1, { ...item, value: base.address })
          }
          if (item.key === 'country') {
            this.formModel.splice(index, 1, { ...item, value: base.country })
          }
          if (item.key === 'dunsNumber') {
            this.formModel.splice(index, 1, { ...item, value: base.dunsNo })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async validate() {
      const valid = await this.$refs.form.validateFields()
      if (valid) {
        const result = this.$refs.form.getFormData()
        result.country = this.countryList.filter(
          item => item.id === result.country,
        )[0].mark
        return result
      }
    },
    async _getCountryList() {
      try {
        const result = await getSelectList('Country')
        this.formModel[0].selectList = result
        this.countryList = result
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
